<section
  class="faq-preview-container"
  [class.faq-preview-container-t2]="theme() === GbTheme.ThemeTwo"
>
  <div class="container">
    @if (theme() === GbTheme.ThemeOne) {
      <app-section-tag text="{{ 'home.faq.title' | translate }}" />
    }
    <div class="row faq-preview-row">
      @if (theme() === GbTheme.ThemeOne) {
        <div class="col-md-5 col-lg-4">
          <div class="left-content-container">
            <h2 class="heading primary-font-semibold">{{ 'home.faq.heading' | translate }}</h2>
            <p class="primary-font-semibold description">
              {{ 'home.faq.description' | translate }}
            </p>
            <button
              class="primary-button custom-button primary-font-semibold rounded-pill view-all-button"
              routerLink="/faq"
            >
              {{ 'home.faq.view_all' | translate }}
            </button>
          </div>
        </div>
      }
      @if (theme() === GbTheme.ThemeTwo) {
        <div class="faq-preview-header">
          <h2 class="heading primary-font-medium">{{ 'home.faq.heading' | translate }}</h2>
          <p class="primary-font-regular description">
            {{ 'home.faq.description' | translate }}
          </p>
        </div>
      }
      <div
        [class.col-md-7]="theme() === GbTheme.ThemeOne"
        [class.col-lg-8]="theme() === GbTheme.ThemeOne"
        [class.col-12]="theme() === GbTheme.ThemeTwo"
      >
        <div class="right-content-container">
          <div class="accordion" id="accordionExample">
            @for (faq of faqs(); track $index) {
              <div class="accordion-item">
                <div class="accordion-header" [id]="`heading${$index}`">
                  <button
                    class="accordion-button primary-font-semibold"
                    [class.collapsed]="$index !== 0"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="`#collapse${$index}`"
                    [attr.aria-expanded]="$index === 0"
                    [attr.aria-controls]="`collapse${$index}`"
                  >
                    <span [innerHTML]="faq.question"></span>
                    @if (theme() === GbTheme.ThemeOne) {
                      <span class="accordion-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="10"
                          viewBox="0 0 17 10"
                          fill="none"
                        >
                          <path d="M1 1L8.5 8.5L16 1" stroke="black" stroke-width="2" />
                        </svg>
                      </span>
                    }

                    @if (theme() === GbTheme.ThemeTwo) {
                      <span class="accordion-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                        >
                          <path
                            d="M15 3.74219V26.2422"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M26.25 14.9961H3.75"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    }
                  </button>
                </div>
                <div
                  [id]="`collapse${$index}`"
                  class="accordion-collapse collapse"
                  [class.show]="$index === 0"
                  [attr.aria-labelledby]="`heading${$index}`"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <span
                      [innerHTML]="faq.answer"
                      class="accordion-body-text primary-font-medium"
                    ></span>
                  </div>
                </div>
              </div>
            }
          </div>

          @if (theme() === GbTheme.ThemeTwo) {
            <div class="view-all-button-container">
              <button
                class="primary-button custom-button primary-font-medium view-all-button"
                routerLink="/faq"
              >
                {{ 'home.faq.view_more' | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
